export const MSG = {
  alpha_numeric: 'Alphanumerics only',
  email_already_exist: 'Email ID already exists',
  email_cannot_empty: 'Email ID cannot be empty',
  email_invalid: 'Email ID is Invalid',
  password_cannot_empty: 'Password cannot be empty',
  login_role_not_allowed: 'This account is not permitted to log in here',
  fieldName_cannot_empty: 'Name cannot be empty',
  fieldId_cannot_empty: 'Id cannot be empty',
  projectName_cannot_empty: 'Project name cannot be empty',
  projectName_length: 'Please enter at least 3 characters',
  projectSlug_cannot_empty: 'Project slug cannot be empty',
  projectSlug_length: 'Please enter at least 4 characters',
  modelName_cannot_empty: 'Project name cannot be empty',
  modelSlug_cannot_empty: 'Project slug cannot be empty',
  enumeration_cannot_empty: 'Enumeration cannot be empty',
  enumerationName_cannot_empty: 'Enumeration name cannot be empty',
  enumerationSlug_cannot_empty: 'Enumeration slug cannot be empty',
  enumerationValues_add_more: 'Enumeration options cannot be empty',
  first_name_cannot_empty: 'First Name cannot be empty',
  last_name_cannot_empty: 'Last Name cannot be empty',
  address_cannot_empty: 'Address cannot be empty',
  city_cannot_empty: 'City cannot be empty',
  state_cannot_empty: 'State cannot be empty',
  country_cannot_empty: 'Country cannot be empty',
  zip_cannot_empty: 'Zipcode cannot be empty',

  confirm_password_cannot_empty: 'Confirm password cannot be empty',
  invalid_password: 'The password should contain atleast six characters length, one number and one special character',
  password_mismatch: 'Confirm password does not match',
  old_password_cannot_empty: 'Old password cannot be empty',
  new_password_cannot_empty: 'New password cannot be empty',

  // User Validation error
  first_name_length: 'First Name must be greater than 1 character',
  last_name_length: 'Last Name must be greater than 1 character',
  password_invalid: 'Password should contain atleast one number and one special character',
  confirm_password_invalid: 'Passwords must match',
  // User alert message
  user_add_success: 'User Added Successfully!',
  user_update_success: 'User Updated Successfully!',
  user_delete_success: 'User Deleted Successfully!',
  // User Role Permission
  module_cannot_empty: 'Module cannot be empty',
  role_cannot_empty: 'Role cannot be empty',
  perm_check_cannot_empty: 'Permission cannot be empty',
  role_perm_add_success: 'Role Permission Added Successfully!',
  role_perm_update_success: 'Role Permission Updated Successfully!',
  // user role Validation error
  user_role_add_success: 'User Role Added Successfully!',
  user_role_delete_success: 'User Role Deleted Successfully!',
  // Role success message
  role_add_success: 'Role Added Successfully!',
  role_update_success: 'Role Updated Successfully!',
  role_delete_success: 'Role Deleted Successfully!',
  // Role Validation error
  role_name_cannot_empty: "Role Name Can't be empty",
  role_desc_cannot_empty: "Role Description Can't be empty",

  servie_name_cannot_empty: 'Service name cannot be empty',
  servie_name_length: 'Please enter at least 3 characters',
  service_min_amount_cannot_empty: 'Service minimum amount cannot be empty',
  service_amount_cannot_empty: 'Service amount cannot be empty',
  service_desc_cannot_empty: 'Service description cannot be empty',
};
